module.exports = __webpack_public_path__ + "media/src/public/img/favicon-d1c65f7b4703d9ea39a19372fb302f94.ico";